package navigation.home.messages

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.client.domain.repository.ClientRepository
import com.essntl.features.message.domain.repository.ConversationRepository
import com.essntl.features.message.ui.all_conversation.AllConversationEvent
import com.essntl.features.message.ui.all_conversation.AllConversationState
import com.essntl.features.message.ui.all_conversation.AllConversationViewModel
import com.essntl.toastmanager.ToastManager

class AllConversationScreenModel(
    conversationRepository: ConversationRepository,
    clientRepository: ClientRepository,
    val toastManager: ToastManager,
    loadingManager: LoadingManager,
) : StateScreenModel<AllConversationState>(AllConversationState()) {

    private val vm = AllConversationViewModel(
        conversationRepository = conversationRepository,
        clientRepository = clientRepository,
        loadingManager = loadingManager,
        scope = screenModelScope,
        state = mutableState,
    )

    fun onEvent(event: AllConversationEvent) = vm.onEvent(event)
}